module.exports = __webpack_public_path__ + "img/hub_solucoes.bd1c830c.webp";